import { z } from 'zod'

import { generateRandomString } from '@mntn-dev/utilities'
import type { ZodInfer } from '@mntn-dev/utility-types'

import { BillingServiceMethodSchema } from './billing/billing-service-method.ts'

export const BillingServiceIdSchema = z
  .string()
  .brand('billing-service-customer')
export type BillingServiceId = ZodInfer<typeof BillingServiceIdSchema>

export const BillingServiceId = (value: string = generateRandomString(16)) => {
  return BillingServiceIdSchema.parse(value)
}

export const BillingServiceCustomFieldSchema = z.object({
  name: z.string(),
  value: z.string(),
})
export type BillingServiceCustomField = ZodInfer<
  typeof BillingServiceCustomFieldSchema
>

export const BillingServiceInvoiceRenderingOptionsSchema = z.object({
  amount_tax_display: z.string().nullable(),
  template: z.string().nullable(),
})

export type BillingServiceInvoiceRenderingOptions = ZodInfer<
  typeof BillingServiceInvoiceRenderingOptionsSchema
>

export const BillingServiceInvoiceSettingsSchema = z.object({
  custom_fields: z
    .union([z.null(), z.literal(''), z.array(BillingServiceCustomFieldSchema)])
    .optional(),
  default_payment_method: z.union([
    z.string(),
    z.null(),
    BillingServiceMethodSchema,
  ]),
  footer: z.string().nullable().optional(),
  rendering_options: BillingServiceInvoiceRenderingOptionsSchema.nullable(),
})

export type BillingServiceInvoiceSettings = ZodInfer<
  typeof BillingServiceInvoiceSettingsSchema
>

export const BillingServiceCustomerSchema = z.object({
  id: BillingServiceIdSchema,
  email: z.email().nullable(),
  name: z.string().optional().nullable(),
  metadata: z.record(z.string(), z.any()).optional(),
  createdAt: z.date().optional(),
  paymentMethods: BillingServiceMethodSchema.array().optional(),
  invoiceSettings: BillingServiceInvoiceSettingsSchema.optional(),
})

export type BillingServiceCustomer = ZodInfer<
  typeof BillingServiceCustomerSchema
>

export const BillingServiceMethodIdSchema = z
  .string()
  .brand('billing-service-method')

export type BillingServiceMethodId = ZodInfer<
  typeof BillingServiceMethodIdSchema
>

export const BillingServiceMethodId = (
  value: string = generateRandomString(16)
) => {
  return BillingServiceMethodIdSchema.parse(value)
}
